import { tv } from 'tailwind-variants'

/**
 * Variants Tailwind unifiés pour les layouts flex (HLayout et VLayout) avec support responsive
 */
export const flexLayoutVariants = tv({
  base: 'flex',
  variants: {
    direction: {
      row: 'flex-row',
      col: 'flex-col',
    },
    gap: {
      '0': 'gap-0',
      '1': 'gap-1',
      '2': 'gap-2',
      '3': 'gap-3',
      '4': 'gap-4',
      '5': 'gap-5',
      '6': 'gap-6',
      '7': 'gap-7',
      '8': 'gap-8',
      '9': 'gap-9',
      '10': 'gap-10',
    },
    gapSm: {
      '0': 'max-sm:gap-0',
      '1': 'max-sm:gap-1',
      '2': 'max-sm:gap-2',
      '3': 'max-sm:gap-3',
      '4': 'max-sm:gap-4',
      '5': 'max-sm:gap-5',
      '6': 'max-sm:gap-6',
      '7': 'max-sm:gap-7',
      '8': 'max-sm:gap-8',
      '9': 'max-sm:gap-9',
      '10': 'max-sm:gap-10',
    },
    gapMd: {
      '0': 'max-md:gap-0',
      '1': 'max-md:gap-1',
      '2': 'max-md:gap-2',
      '3': 'max-md:gap-3',
      '4': 'max-md:gap-4',
      '5': 'max-md:gap-5',
      '6': 'max-md:gap-6',
      '7': 'max-md:gap-7',
      '8': 'max-md:gap-8',
      '9': 'max-md:gap-9',
      '10': 'max-md:gap-10',
    },
    gapLg: {
      '0': 'max-lg:gap-0',
      '1': 'max-lg:gap-1',
      '2': 'max-lg:gap-2',
      '3': 'max-lg:gap-3',
      '4': 'max-lg:gap-4',
      '5': 'max-lg:gap-5',
      '6': 'max-lg:gap-6',
      '7': 'max-lg:gap-7',
      '8': 'max-lg:gap-8',
      '9': 'max-lg:gap-9',
      '10': 'max-lg:gap-10',
    },
    gapXl: {
      '0': 'max-xl:gap-0',
      '1': 'max-xl:gap-1',
      '2': 'max-xl:gap-2',
      '3': 'max-xl:gap-3',
      '4': 'max-xl:gap-4',
      '5': 'max-xl:gap-5',
      '6': 'max-xl:gap-6',
      '7': 'max-xl:gap-7',
      '8': 'max-xl:gap-8',
      '9': 'max-xl:gap-9',
      '10': 'max-xl:gap-10',
    },
    items: {
      start: 'items-start',
      center: 'items-center',
      end: 'items-end',
      stretch: 'items-stretch',
      baseline: 'items-baseline',
    },
    itemsSm: {
      start: 'max-sm:items-start',
      center: 'max-sm:items-center',
      end: 'max-sm:items-end',
      stretch: 'max-sm:items-stretch',
      baseline: 'max-sm:items-baseline',
    },
    itemsMd: {
      start: 'max-md:items-start',
      center: 'max-md:items-center',
      end: 'max-md:items-end',
      stretch: 'max-md:items-stretch',
      baseline: 'max-md:items-baseline',
    },
    itemsLg: {
      start: 'max-lg:items-start',
      center: 'max-lg:items-center',
      end: 'max-lg:items-end',
      stretch: 'max-lg:items-stretch',
      baseline: 'max-lg:items-baseline',
    },
    itemsXl: {
      start: 'max-xl:items-start',
      center: 'max-xl:items-center',
      end: 'max-xl:items-end',
      stretch: 'max-xl:items-stretch',
      baseline: 'max-xl:items-baseline',
    },
    justify: {
      start: 'justify-start',
      center: 'justify-center',
      end: 'justify-end',
      between: 'justify-between',
      around: 'justify-around',
      evenly: 'justify-evenly',
    },
    justifySm: {
      start: 'max-sm:justify-start',
      center: 'max-sm:justify-center',
      end: 'max-sm:justify-end',
      between: 'max-sm:justify-between',
      around: 'max-sm:justify-around',
      evenly: 'max-sm:justify-evenly',
    },
    justifyMd: {
      start: 'max-md:justify-start',
      center: 'max-md:justify-center',
      end: 'max-md:justify-end',
      between: 'max-md:justify-between',
      around: 'max-md:justify-around',
      evenly: 'max-md:justify-evenly',
    },
    justifyLg: {
      start: 'max-lg:justify-start',
      center: 'max-lg:justify-center',
      end: 'max-lg:justify-end',
      between: 'max-lg:justify-between',
      around: 'max-lg:justify-around',
      evenly: 'max-lg:justify-evenly',
    },
    justifyXl: {
      start: 'max-xl:justify-start',
      center: 'max-xl:justify-center',
      end: 'max-xl:justify-end',
      between: 'max-xl:justify-between',
      around: 'max-xl:justify-around',
      evenly: 'max-xl:justify-evenly',
    },
    self: {
      auto: 'self-auto',
      start: 'self-start',
      center: 'self-center',
      end: 'self-end',
      stretch: 'self-stretch',
      baseline: 'self-baseline',
    },
    selfSm: {
      auto: 'max-sm:self-auto',
      start: 'max-sm:self-start',
      center: 'max-sm:self-center',
      end: 'max-sm:self-end',
      stretch: 'max-sm:self-stretch',
      baseline: 'max-sm:self-baseline',
    },
    selfMd: {
      auto: 'max-md:self-auto',
      start: 'max-md:self-start',
      center: 'max-md:self-center',
      end: 'max-md:self-end',
      stretch: 'max-md:self-stretch',
      baseline: 'max-md:self-baseline',
    },
    selfLg: {
      auto: 'max-lg:self-auto',
      start: 'max-lg:self-start',
      center: 'max-lg:self-center',
      end: 'max-lg:self-end',
      stretch: 'max-lg:self-stretch',
      baseline: 'max-lg:self-baseline',
    },
    selfXl: {
      auto: 'max-xl:self-auto',
      start: 'max-xl:self-start',
      center: 'max-xl:self-center',
      end: 'max-xl:self-end',
      stretch: 'max-xl:self-stretch',
      baseline: 'max-xl:self-baseline',
    },
    wrap: {
      nowrap: 'flex-nowrap',
      wrap: 'flex-wrap',
      'wrap-reverse': 'flex-wrap-reverse',
    },
    wrapSm: {
      nowrap: 'max-sm:flex-nowrap',
      wrap: 'max-sm:flex-wrap',
      'wrap-reverse': 'max-sm:flex-wrap-reverse',
    },
    wrapMd: {
      nowrap: 'max-md:flex-nowrap',
      wrap: 'max-md:flex-wrap',
      'wrap-reverse': 'max-md:flex-wrap-reverse',
    },
    wrapLg: {
      nowrap: 'max-lg:flex-nowrap',
      wrap: 'max-lg:flex-wrap',
      'wrap-reverse': 'max-lg:flex-wrap-reverse',
    },
    wrapXl: {
      nowrap: 'max-xl:flex-nowrap',
      wrap: 'max-xl:flex-wrap',
      'wrap-reverse': 'max-xl:flex-wrap-reverse',
    },
  },
  defaultVariants: {
    gap: '0',
  },
})
